import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState, store } from "store";

export default function useCheckoutContact() {
  const { user } = useSelector((state: RootState) => state.auth);

  console.log("user : ", user);

  const [email, setEmail] = useState<any>(user?.["contact_email"]);
  const [phone, setPhone] = useState<any>(user?.["contact_phone"]);
  const [remarks, setRemarks] = useState<any>();

  const _onEmailChange = (value: string) => {
    setEmail(value);
  };

  const _onPhoneChange = (value: string) => {
    setPhone(value);
  };

  const _onRemarksChange = (value: string) => {
    setRemarks(value);
  };

  return { user, email, phone, instagram_id: user?.["instagram_id"], first_name: user?.["first_name"], last_name: user?.["last_name"], remarks, _onEmailChange, _onPhoneChange, _onRemarksChange };
}
